module.exports = __webpack_public_path__ + "img/packed.b20126dc.png";